import {remCalc} from '../../_utils'

const getStyles = () => {
    return {
        flexContainer: {
            display: 'flex',
            width: '100%',
            py: ['large.base', 'large.sm', 'large.md', 'large.lg'],
            flexDirection: 'column',
            alignItems: 'center',
            gap: remCalc(40),
            backgroundColor: 'background.light',
        },
        awardsContainer: {
            display: 'flex',
            flexWrap: 'wrap',
            maxWidth: {lg: remCalc(1162)},
            justifyContent: ['unset', 'unset', 'unset', 'center'],
            alignItems: ['center', 'center', 'center', 'flex-start'],
            gap: [remCalc(24), remCalc(24), remCalc(24), remCalc(250)],
            flexDirection: ['column', 'column', 'column', 'unset'],
        },
        award: {
            display: 'flex',
            width: [remCalc(352), remCalc(352), remCalc(352), remCalc(450)],
            flexDirection: 'column',
            alignItems: 'center',
            gap: remCalc(16),
        },
        image: {
            height: [remCalc(160), remCalc(160), remCalc(160), remCalc(200)],
            alignSelf: 'stretch',
            backgroundBlendMode: 'multiply',
            backgroundColor: [
                'background.light',
                'background.light',
                'background.light',
                'background.light',
            ],
        },
        title: {
            alignSelf: 'stretch',
            textStyle: 'head-small',
            color: 'text.default',
            textAlign: 'center',
            fontWeight: 'medium',
        },
        description: {
            alignSelf: 'stretch',
            textStyle: 'body-large',
            color: 'text.default',
            textAlign: 'center',
            fontWeight: 'normal',
        },
    }
}

export default {
    baseStyle: getStyles,
}
